/**
 * Rounded "pill cluster" container that groups related top-bar icon buttons
 * (per the top-bar design). Light mode uses a soft neutral well; the dark
 * (navy) chrome uses a translucent white well.
 */
const NavPillGroup = ({ isDark, className = "", children }) => (
  <div
    className={`flex items-center gap-0.5 p-0.5 rounded-full ${
      isDark ? "bg-white/[0.06]" : "bg-surface-muted"
    } ${className}`}
  >
    {children}
  </div>
);

export default NavPillGroup;
